import { render, staticRenderFns } from "./SponserProgramTable.vue?vue&type=template&id=1f70d80d&scoped=true"
import script from "./SponserProgramTable.vue?vue&type=script&lang=js"
export * from "./SponserProgramTable.vue?vue&type=script&lang=js"
import style0 from "./SponserProgramTable.vue?vue&type=style&index=0&id=1f70d80d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f70d80d",
  null
  
)

export default component.exports